import axios from 'axios';
const { REACT_APP_API_FULL_PATH } = process.env;

export const API = {
  fetch: (path: string, lang: string) => {
    return axios.get(REACT_APP_API_FULL_PATH + '/' + path);
  },
};
